export default __webpack_public_path__ + "static/blog-03-900x678-4d809b3fa42ee6223e8784cf22274f8a.jpg";